<div class="flex h-[200px] flex-col items-center justify-center">
  <div class="mb-4 text-xl font-semibold">No invoice activities have been mapped</div>

  <div class="mb-4 text-sm">Click Map Activities to map invoices to Budget Activities</div>

  <aux-button
    variant="primary"
    label="Map Activities"
    data-pendo-id="map-activities-button"
    [auxTooltip]="btnTooltip()"
    [disabled]="!!btnTooltip()"
    (clickEmit)="openMapActivitiesModal()"
  ></aux-button>
</div>
